import styled from 'styled-components'
import { devices } from '../../../../../globalStyle'

export const Container = styled.div`
    position: absolute;
    display: flex;
    background-color: #fff;
    width: 11vw;
    max-height: 20vh;
    top: 5.3vh;
    white-space: break-spaces;
    overflow-y: auto;
    overflow-x: hidden;
    flex-direction: column;
    z-index: 2;
    border: 1px solid #ebebeb;
    @media ${devices.largeDesktop} {
        width:9vw;   
    }
    `
    
    export const FiltersDiv = styled.div`
    display: flex;
    width: 11vw;
    height: 5vh;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    @media ${devices.largeDesktop} {
        width:9vw;   
    }
    
    :hover{
        background-color: #f5f5f5;
        }
        `
        
        export const FiltersText = styled.p`
        font-size: 0.8vw;
        @media ${devices.largeDesktop} {
            font-size:0.7vw;  
        }
`
